import { edmCampaign } from '@bingads-webui/edm-campaign';

const isLocal = () => {
  const hostname = document.location.hostname.toLowerCase();
  return hostname.indexOf('ads.microsoft.com') === -1 &&
      hostname.indexOf('ads-int.microsoft.com') === -1;
};

export const loadLinkedInCompanyPages = (cid, aid, payload) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .LinkedInCompanyPages['Default.LoadLinkedInCompanyPages']
    .$makeCall({
      payload,
      bypassCache: true,
    })
    .toPromise();

export const getConnectedLinkedInCompanyPage = (cid, aid) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .LinkedInCompanyPages['Default.GetConnectedLinkedInCompanyPage']
    .$makeCall({
      bypassCache: true,
    })
    .toPromise()
    .catch((err) => {
      if (isLocal()) {
        // Ignore error in local/CI environment to unblock E2E tests
        return Promise.resolve({});
      }

      throw err;
    });

export const getCompanyPagePermissionStatus = (cid, aid) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .LinkedInCompanyPages['Default.GetCompanyPagePermissionStatus']
    .$makeCall({
      bypassCache: true,
    })
    .toPromise();

export const connectToLinkedInCompanyPage = (cid, aid, payload) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .LinkedInCompanyPages['Default.ConnectToLinkedInCompanyPage']
    .$makeCall({
      payload,
      bypassCache: true,
    })
    .toPromise();

export const typeaheadCompanyPageSearch = (cid, aid, query) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .LinkedInCompanyPages['Default.TypeaheadCompanyPageSearch']
  .$makeCall({
    payload: { query },
  })
  .toPromise();

export const reauthLinkedInMember = (cid, aid, payload) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .LinkedInCompanyPages['Default.ReauthLinkedInMember']
    .$makeCall({
      payload,
      bypassCache: true,
    })
    .toPromise();

